import storageService from '../services/storageService'
import { SortTypes } from './constants'
import allLocales from '../i18n/locales'
import { useLocalePathPrefix, useAppPathPrefix } from './getWebsiteUrl'
// Re-export browser utilities from @repo/utils
export { isBrowser, isMobile, detectBrowser, generateUEID } from '@repo/utils'

export const parseQueryString = (string) => {
  const query = {}

  if (string) {
    string = string.charAt(0) === '?' ? string.slice(1) : string
    string.split('&').forEach((queryParam) => {
      const [key, value] = queryParam.split('=')
      query[key] = value
    })
  }

  return query
}

export const convertOptionsToQueryParams = (options) => {
  return options
    .map(
      ({ param, value }) =>
        `${encodeURIComponent(param)}=${encodeURIComponent(value)}`
    )
    .join('&')
}

const removeAppPathPrefixFromURL = (url) => {
  if (!url) return '/'
  
  if (!useAppPathPrefix && url) return url

  return url?.replaceAll('/app/', '/')
}

export const removeLocaleFromURL = (url) => {
  if (!useLocalePathPrefix && url) return removeAppPathPrefixFromURL(url)

  if (!url) return '/'
  if (!url.includes('?') && url.charAt(url.length - 1) != '/') url += '/'

  Object.keys(allLocales).forEach((locale) => {
    url = url.replaceAll(`/${locale}/`, '/')
  })
  return removeAppPathPrefixFromURL(url) || '/'
}

export const removeHTMLFromString = (string) => {
  if (!isBrowser()) return
  const tmp = document.createElement('div')
  tmp.innerHTML = string
  return tmp.textContent || tmp.innerText || ''
}

export const sortGames = (games, sortKeyword) => {
  const safeGames = [...games]

  switch (sortKeyword) {
    case SortTypes.A_Z:
      return safeGames.sort((a, b) => a.title.localeCompare(b.title))
    case SortTypes.Z_A:
      return safeGames.sort((a, b) => b.title.localeCompare(a.title))
    case SortTypes.NEWEST_OLDEST:
      return safeGames.sort((a, b) => a.created_at.localeCompare(b.created_at))
    case SortTypes.OLDEST_NEWEST:
      return safeGames.sort((a, b) => b.created_at.localeCompare(a.created_at))
    case SortTypes.POPULAR:
      return safeGames.sort((a) =>
        a.game_tags?.includes('gametag_top') ? -1 : 0
      )
    default:
      return safeGames
  }
}

export const getCasinoBackLink = (casinoSlug, liveCasinoSlug) => {
  const lobby = storageService.getValue('lobby')

  if (lobby?.includes(liveCasinoSlug)) {
    return `/${liveCasinoSlug}/`
  } else {
    return `/${casinoSlug}/`
  }
}
